'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { ProductTab } from '@/types/coolxprint2'
import { ArrowRight } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'

interface CategoryQuickTabsProps {
  tabs: ProductTab[]
}

export function CategoryQuickTabs({ tabs }: CategoryQuickTabsProps) {
  if (!tabs || tabs.length === 0) {
    return null
  }

  return (
    <div className='absolute bottom-0 left-1/2 top-1/2 z-10 w-full -translate-x-1/2 translate-y-[60%] px-4 md:px-0'>
      <div
        className='mx-auto flex w-full max-w-7xl gap-3 overflow-x-auto md:justify-center md:gap-4'
        style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .category-tabs-scroll::-webkit-scrollbar {
                display: none;
              }
            `,
          }}
        />
        <div className='category-tabs-scroll flex flex-nowrap gap-3 md:gap-4'>
          {tabs.map((tab) => {
            // if (!tab.view_all_link) {
            //   return null
            // }

            // Check if icon is SVG content or image URL
            const isSvgContent =
              tab.icon?.trim().startsWith('<svg') ||
              tab.icon?.trim().startsWith('<SVG')

            return (
              <Link
                key={tab.id}
                href={tab.view_all_link || ''}
                className='group flex min-w-[140px] flex-shrink-0 items-center gap-3 rounded-xl bg-white px-4 py-3 transition-all md:min-w-[180px] md:gap-4 md:px-6 md:py-4'
              >
                {/* Icon */}
                {tab.icon && (
                  <div className='flex-shrink-0'>
                    {isSvgContent ? (
                      // SVG content
                      <div
                        className='h-8 w-8 text-neutral-900 group-hover:text-[#ff4e00] md:h-10 md:w-10 [&_svg]:h-full [&_svg]:w-full'
                        dangerouslySetInnerHTML={{ __html: tab.icon }}
                      />
                    ) : (
                      // Image URL
                      <Image
                        src={ImageHelper.getImageUrl(tab.icon)}
                        alt={tab.label}
                        width={40}
                        height={40}
                        className='h-8 w-8 object-contain transition-opacity group-hover:opacity-80 md:h-10 md:w-10'
                      />
                    )}
                  </div>
                )}

                {/* Label */}
                <span className='font-formaDjr flex-1 text-sm font-medium text-neutral-900 group-hover:text-[#ff4e00] md:text-base'>
                  {tab.label}
                </span>

                {/* Arrow Button */}
                <div className='flex-shrink-0'>
                  <div className='flex h-7 w-7 items-center justify-center rounded-lg border border-neutral-900 transition-colors group-hover:border-[#ff4e00] group-hover:bg-[#ff4e00] md:h-8 md:w-8'>
                    <ArrowRight className='h-4 w-4 text-neutral-900 transition-colors group-hover:text-white md:h-5 md:w-5' />
                  </div>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}
